import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { treeItemClasses, TreeItem as TreeItem$1 } from '@mui/lab';
import { archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material';
import '@mui/material/styles';
import 'uuid/v4';
var _excluded = ["sx"];

var _treeItemHover;

var styles = {
  treeItemHover: (_treeItemHover = {}, _defineProperty(_treeItemHover, "& .".concat(treeItemClasses['label'], ":hover"), {
    backgroundColor: archerConstants.archerHover
  }), _defineProperty(_treeItemHover, "& .".concat(treeItemClasses['content'], ":hover"), {
    backgroundColor: 'transparent'
  }), _treeItemHover)
};

var TreeItem = function TreeItem(_ref) {
  var sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TreeItem$1, _extends({
    sx: [styles.treeItemHover, sx]
  }, rest));
};

TreeItem.displayName = 'TreeItem';
export { TreeItem };